import { useTalkRoomDocument } from "@mgdx/talk/hooks/useTalkRoomDocument";
import { useTalkRoomTitle } from "@mgdx/talk/hooks/useTalkRoomTitle";
import { SenderTypeEnum } from "@mgdx/talk/models/TalkMessageDocument";
import { useTalkState, useTalkStore } from "@mgdx/talk/providers/TalkStoreProvider";
import { Modal } from "@mgdx/ui/components/Modal";
import { useCallback, useId } from "react";

import { DialogLayout } from "../../ui/DialogLayout";
import { TalkMessageListContent } from "./TalkMessageListContent";

export const TalkMessageListModal = () => {
  const { clearSelectedTalkRoomId, closeTalk } = useTalkStore((state) => state.actions);
  const handleRequestRefresh = useCallback(async () => {
    window.location.reload();
  }, []);

  const handleRequestBackOrClose = useCallback(async () => {
    clearSelectedTalkRoomId();
    closeTalk();
  }, [clearSelectedTalkRoomId, closeTalk]);

  const { isEnabledTalk, isOpenTalk, selectedTalkRoomId, talkOpenedFromFab } = useTalkState();

  const { room } = useTalkRoomDocument({
    roomId: selectedTalkRoomId,
  });

  const title = useTalkRoomTitle({
    room,
    talkSenderType: SenderTypeEnum.Patient,
  });

  const titleId = useId();

  return (
    <Modal
      open={isEnabledTalk && isOpenTalk}
      size="full"
      aria-labelledby={titleId}
      onRequestClose={handleRequestBackOrClose}
    >
      <DialogLayout
        title={title}
        titleId={titleId}
        onRequestClose={handleRequestBackOrClose}
        onRequestBack={handleRequestBackOrClose}
        onRequestRefresh={handleRequestRefresh}
      >
        {selectedTalkRoomId && (
          <TalkMessageListContent roomId={selectedTalkRoomId} showCounselingLink={!talkOpenedFromFab} />
        )}
      </DialogLayout>
    </Modal>
  );
};
